var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_7390)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99984 5.54297C6.61306 5.54297 6.24213 5.69661 5.96864 5.9701C5.69515 6.24359 5.5415 6.61453 5.5415 7.0013V21.0013C5.5415 21.3881 5.69515 21.759 5.96864 22.0325C6.24213 22.306 6.61306 22.4596 6.99984 22.4596H20.9998C21.3866 22.4596 21.7575 22.306 22.031 22.0325C22.3045 21.759 22.4582 21.3881 22.4582 21.0013V7.0013C22.4582 6.61453 22.3045 6.2436 22.031 5.9701C21.7575 5.69661 21.3866 5.54297 20.9998 5.54297H6.99984ZM4.7312 4.73267C5.33288 4.13099 6.14893 3.79297 6.99984 3.79297H20.9998C21.8507 3.79297 22.6668 4.13099 23.2685 4.73267C23.8701 5.33435 24.2082 6.1504 24.2082 7.0013V21.0013C24.2082 21.8522 23.8701 22.6683 23.2685 23.2699C22.6668 23.8716 21.8507 24.2096 20.9998 24.2096H6.99984C6.14893 24.2096 5.33288 23.8716 4.7312 23.2699C4.12952 22.6683 3.7915 21.8522 3.7915 21.0013V7.0013C3.7915 6.1504 4.12952 5.33435 4.7312 4.73267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 11.957C9.81675 11.957 10.2085 12.3488 10.2085 12.832V18.6654C10.2085 19.1486 9.81675 19.5404 9.3335 19.5404C8.85025 19.5404 8.4585 19.1486 8.4585 18.6654V12.832C8.4585 12.3488 8.85025 11.957 9.3335 11.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 8.45703C9.81675 8.45703 10.2085 8.84878 10.2085 9.33203V9.3437C10.2085 9.82695 9.81675 10.2187 9.3335 10.2187C8.85025 10.2187 8.4585 9.82695 8.4585 9.3437V9.33203C8.4585 8.84878 8.85025 8.45703 9.3335 8.45703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6654V12.832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0647 12.8967C14.6664 12.2951 15.4824 11.957 16.3333 11.957C17.1842 11.957 18.0003 12.2951 18.602 12.8967C19.2036 13.4984 19.5417 14.3145 19.5417 15.1654V18.6654C19.5417 19.1486 19.1499 19.5404 18.6667 19.5404C18.1834 19.5404 17.7917 19.1486 17.7917 18.6654V15.1654C17.7917 14.7786 17.638 14.4077 17.3645 14.1342C17.091 13.8607 16.7201 13.707 16.3333 13.707C15.9466 13.707 15.5756 13.8607 15.3021 14.1342C15.0286 14.4077 14.875 14.7786 14.875 15.1654C14.875 15.6486 14.4832 16.0404 14 16.0404C13.5168 16.0404 13.125 15.6486 13.125 15.1654C13.125 14.3145 13.463 13.4984 14.0647 12.8967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_7390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6556b7162fbda29185ced8d0a27b0bc3.svg";
export { ForwardRef as ReactComponent };